import { useCallback, useEffect, useRef } from 'react';

import User from '@/assets/icons/User';
import { useBamAuth } from '@/auth';
import { useAuth } from '@/utils/auth/context';
import { isSecurityEnabled } from '@/utils/devModeConfig';

import styles from '@/components/navBar/Navbar.module.css';

function AuthStatus() {
  const { isLoggedIn } = useBamAuth();
  const auth = useAuth();
  const loginInProgress = useRef(false);

  useEffect(() => {
    const handleAuth = async () => {
      if (!isLoggedIn && isSecurityEnabled() && !loginInProgress.current && !auth.loginError) {
        loginInProgress.current = true;
        await auth.login();
      }
    };

    if (auth.provider === 'bff-cookie' && !auth.isLoading) {
      handleAuth().then(() => console.log('authenticated'));
    }
  }, [isLoggedIn, auth]);

  const userClick = useCallback(async () => {
    if (!isLoggedIn) {
      await auth.login();
    } else {
      await auth.logout();
    }
  }, [auth, isLoggedIn]);

  const tooltipText = auth.user?.username ? `(${auth.user.username}) Log uit` : 'Log in';
  const logInText = isSecurityEnabled() ? 'Log in' : 'dev';

  return !auth.isLoading ? (
    <div
      onKeyDown={(e) => e.key === 'Enter' && isSecurityEnabled() && userClick()}
      tabIndex={0}
      className={styles.navBarUserStyle}
      onClick={() => isSecurityEnabled() && userClick()}
      title={tooltipText}
      data-dd-action-name={isLoggedIn ? 'User menu: log uit' : 'User menu: log in'}
    >
      <User height='24px' width='24px' aria-label='User' data-testid='UserIcon' />
      <div className={styles.navBarUserNameStyle}>
        <span>{isLoggedIn ? (auth.user?.firstName ? `(${auth.user.firstName}) Log uit` : 'Log uit') : logInText}</span>
      </div>
    </div>
  ) : null;
}

export default AuthStatus;
